<template>
   <button class="modal__button" @click="handleInputDelete">
        <i class="button__image">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
        </i>
    </button>
</template>

<script setup>
import { popStore } from "@/helper/popStore"
const props = defineProps({
    index: Number
})
const handleInputDelete = (e) => {
    popStore.value.splice(props.index, 1)
}
</script>

<style>

</style>